import { publicApi } from "./orderApi";

const SDK = "https://checkout.razorpay.com/v1/checkout.js";
let sdkPromise = null;

export const loadRazorpay = () => {
  if (window.Razorpay) return Promise.resolve();
  if (!sdkPromise) {
    sdkPromise = new Promise((res, rej) => {
      const s = document.createElement("script");
      s.src = SDK; s.async = true;
      s.onload = () => res(); s.onerror = () => { sdkPromise = null; rej(new Error("razorpay_sdk_failed")); };
      document.body.appendChild(s);
    });
  }
  return sdkPromise;
};

/** Opens Razorpay Checkout for an intent. Resolves {razorpay_order_id, razorpay_payment_id, razorpay_signature} or rejects {code:"dismissed"|"failed"}. */
export const openRazorpay = ({ intent, brand, customer }) => new Promise((resolve, reject) => {
  loadRazorpay().then(() => {
    const rzp = new window.Razorpay({
      key: intent.key_id, amount: intent.amount_paise, currency: intent.currency || "INR", order_id: intent.rzp_order_id,
      name: brand?.name || "Order", image: brand?.logo_url || undefined, description: "Online order",
      prefill: { name: customer?.name || "", contact: customer?.phone ? `+91${customer.phone}` : "" },
      theme: { color: brand?.primary_color || "#1f2937" },
      modal: { ondismiss: () => reject({ code: "dismissed" }) },
      handler: (r) => resolve(r),
    });
    rzp.on("payment.failed", (r) => reject({ code: "failed", message: r?.error?.description }));
    rzp.open();
  }).catch(reject);
});

/** MOCKED gateway path (Preview only, backend ONLINE_GATEWAY_MOCK=true). */
export const mockPay = (slug, requestId, t, method = "upi") =>
  publicApi.post(`/${slug}/payments/${requestId}/mock-pay`, null, { params: { t, method } }).then((r) => r.data);

export const verifyPayment = (slug, requestId, t, r) =>
  publicApi.post(`/${slug}/payments/verify`, { request_id: requestId, t, razorpay_order_id: r.razorpay_order_id, razorpay_payment_id: r.razorpay_payment_id, razorpay_signature: r.razorpay_signature }).then((x) => x.data);

export const accountKey = (slug) => `sc_online_account_${slug}`;
export const getAccountToken = (slug) => localStorage.getItem(accountKey(slug)) || "";
